// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tippy_tippy-box__oFvhA[data-animation=fade][data-state=hidden] {
  opacity: 0;
}

[data-tippy-root] {
  max-width: calc(100vw - 10px);
}

.tippy_tippy-box__oFvhA {
  position: relative;
  background-color: #333;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.4;
  white-space: normal;
  outline: 0;
  transition-property: transform, visibility, opacity;
}

.tippy_tippy-box__oFvhA[data-placement^=top] > .tippy_tippy-arrow__BzgmR {
  bottom: 0;
}

.tippy_tippy-box__oFvhA[data-placement^=top] > .tippy_tippy-arrow__BzgmR:before {
  bottom: -7px;
  left: 0;
  border-width: 8px 8px 0;
  border-top-color: initial;
  transform-origin: center top;
}

.tippy_tippy-box__oFvhA[data-placement^=bottom] > .tippy_tippy-arrow__BzgmR {
  top: 0;
}

.tippy_tippy-box__oFvhA[data-placement^=bottom] > .tippy_tippy-arrow__BzgmR:before {
  top: -7px;
  left: 0;
  border-width: 0 8px 8px;
  border-bottom-color: initial;
  transform-origin: center bottom;
}

.tippy_tippy-box__oFvhA[data-placement^=left] > .tippy_tippy-arrow__BzgmR {
  right: 0;
}

.tippy_tippy-box__oFvhA[data-placement^=left] > .tippy_tippy-arrow__BzgmR:before {
  border-width: 8px 0 8px 8px;
  border-left-color: initial;
  right: -7px;
  transform-origin: center left;
}

.tippy_tippy-box__oFvhA[data-placement^=right] > .tippy_tippy-arrow__BzgmR {
  left: 0;
}

.tippy_tippy-box__oFvhA[data-placement^=right] > .tippy_tippy-arrow__BzgmR:before {
  left: -7px;
  border-width: 8px 8px 8px 0;
  border-right-color: initial;
  transform-origin: center right;
}

.tippy_tippy-box__oFvhA[data-inertia][data-state=visible] {
  transition-timing-function: cubic-bezier(0.54, 1.5, 0.38, 1.11);
}

.tippy_tippy-arrow__BzgmR {
  width: 16px;
  height: 16px;
  color: #333;
}

.tippy_tippy-arrow__BzgmR:before {
  content: "";
  position: absolute;
  border-color: transparent;
  border-style: solid;
}

.tippy_tippy-content__7vkBC {
  position: relative;
  padding: 5px 9px;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./node_modules/tippy.js/dist/tippy.css"],"names":[],"mappings":"AAAA;EAAmD,UAAA;AAEnD;;AAF6D;EAAkB,6BAAA;AAM/E;;AAN4G;EAAW,kBAAA;EAAkB,sBAAA;EAAsB,WAAA;EAAW,kBAAA;EAAkB,eAAA;EAAe,gBAAA;EAAgB,mBAAA;EAAmB,UAAA;EAAU,mDAAA;AAkBxP;;AAlByS;EAA6C,SAAA;AAsBtV;;AAtB+V;EAAoD,YAAA;EAAY,OAAA;EAAO,uBAAA;EAAuB,yBAAA;EAAyB,4BAAA;AA8Btd;;AA9Bkf;EAAgD,MAAA;AAkCliB;;AAlCwiB;EAAuD,SAAA;EAAS,OAAA;EAAO,uBAAA;EAAuB,4BAAA;EAA4B,+BAAA;AA0ClqB;;AA1CisB;EAA8C,QAAA;AA8C/uB;;AA9CuvB;EAAqD,2BAAA;EAA2B,0BAAA;EAA0B,WAAA;EAAW,6BAAA;AAqD52B;;AArDy4B;EAA+C,OAAA;AAyDx7B;;AAzD+7B;EAAsD,UAAA;EAAU,2BAAA;EAA2B,2BAAA;EAA2B,8BAAA;AAgErjC;;AAhEmlC;EAA6C,+DAAA;AAoEhoC;;AApE0rC;EAAa,WAAA;EAAW,YAAA;EAAY,WAAA;AA0E9tC;;AA1EyuC;EAAoB,WAAA;EAAW,kBAAA;EAAkB,yBAAA;EAAyB,mBAAA;AAiFnzC;;AAjFs0C;EAAe,kBAAA;EAAkB,gBAAA;EAAgB,UAAA;AAuFv3C","sourcesContent":[".tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{position:relative;background-color:#333;color:#fff;border-radius:4px;font-size:14px;line-height:1.4;white-space:normal;outline:0;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{bottom:-7px;left:0;border-width:8px 8px 0;border-top-color:initial;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{top:-7px;left:0;border-width:0 8px 8px;border-bottom-color:initial;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-width:8px 0 8px 8px;border-left-color:initial;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{left:-7px;border-width:8px 8px 8px 0;border-right-color:initial;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{width:16px;height:16px;color:#333}.tippy-arrow:before{content:\"\";position:absolute;border-color:transparent;border-style:solid}.tippy-content{position:relative;padding:5px 9px;z-index:1}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tippy-box": `tippy_tippy-box__oFvhA`,
	"tippy-arrow": `tippy_tippy-arrow__BzgmR`,
	"tippy-content": `tippy_tippy-content__7vkBC`
};
export default ___CSS_LOADER_EXPORT___;
